"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _IconSVG = _interopRequireDefault(require("../components/IconSVG"));
var _excluded = ["size", "title", "ariaHidden"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var pathSizesToPaths = {
  "16": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M2.973 0H2.49a.47.47 0 0 0-.471.47v15.059a.47.47 0 0 0 .47.471h10.634a.47.47 0 0 0 .47-.471V.47a.47.47 0 0 0-.47-.47h-9.15v.941h8.68v14.118H2.96V.941h.013V0Zm3.515 4.785c0 .3-.131.444-.46.444h-.343v-.86h.339c.329 0 .464.128.464.416Zm-.384-.855H5.08v2.771h.612V5.625h.367l.572 1.076h.652l-.66-1.212v-.016c.301-.124.484-.324.484-.712 0-.564-.339-.831-1.003-.831ZM7.572 6.7h.612V3.93h-.612V6.7Zm2.563-1.863c0 .308-.132.456-.468.456H9.31v-.92h.368c.32 0 .456.12.456.464Zm-.393-.907H8.698V6.7h.612v-.987h.46c.628 0 1-.312 1-.912 0-.56-.34-.871-1.028-.871Z"
  }),
  "24": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M4.428 0h-.631a.537.537 0 0 0-.537.537v22.926c0 .296.24.537.537.537h16.187c.297 0 .538-.24.538-.537V.537A.538.538 0 0 0 19.984 0H5.553v1.202h13.806v21.597H4.422V1.2h.006V0Zm5.186 7.01c0 .508-.223.75-.777.75h-.58V6.31h.573c.554 0 .784.217.784.702Zm-.648-1.444H7.237v4.68H8.27V8.428h.621l.966 1.816h1.1L9.844 8.2v-.027c.507-.21.817-.547.817-1.202 0-.952-.575-1.405-1.695-1.405Zm2.482 4.68h1.034v-4.68h-1.034v4.68Zm4.329-3.147c0 .52-.223.77-.79.77h-.601V6.316h.62c.541 0 .771.202.771.783Zm-.662-1.533h-1.763v4.68h1.033V8.578h.777c1.06 0 1.688-.527 1.688-1.54 0-.945-.574-1.472-1.735-1.472Z"
  }),
  "32": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M5.904 0h-.841a.716.716 0 0 0-.716.716v30.568c0 .395.32.716.716.716h21.583a.717.717 0 0 0 .717-.716V.716A.717.717 0 0 0 26.646 0H7.404v1.602h18.409v28.796H5.896V1.602h.008V0Zm6.915 9.348c0 .676-.297 1-1.035 1h-.774V8.412h.764c.739 0 1.045.289 1.045.936Zm-.865-1.926H9.65v6.239h1.377v-2.422h.828l1.288 2.422h1.467l-1.485-2.728v-.036c.676-.28 1.09-.73 1.09-1.602 0-1.27-.766-1.873-2.26-1.873Zm3.31 6.24h1.379v-6.24h-1.378v6.24Zm5.77-4.196c0 .693-.296 1.026-1.052 1.026h-.802V8.42h.828c.72 0 1.027.27 1.027 1.045Zm-.881-2.044h-2.35v6.239h1.377v-2.224h1.035c1.414 0 2.25-.702 2.25-2.052 0-1.261-.764-1.963-2.312-1.963Z"
  }),
  "48": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M8.5.077h-.977a.938.938 0 0 0-.937.938v46.003c0 .518.42.938.937.938h32.789c.518 0 .937-.42.937-.938V1.015a.937.937 0 0 0-.937-.938H10.374v1.875h29v44.129H8.461V1.952h.038V.077Zm10.836 15.024c0 1.013-.445 1.499-1.553 1.499h-1.161v-2.903h1.147c1.108 0 1.567.432 1.567 1.404Zm-1.296-2.89h-3.457v9.359h2.066v-3.633h1.243l1.93 3.633h2.202l-2.229-4.093v-.053c1.013-.419 1.634-1.094 1.634-2.403 0-1.905-1.148-2.81-3.389-2.81Zm4.967 9.359h2.066v-9.359h-2.066v9.359Zm8.654-6.294c0 1.04-.445 1.54-1.58 1.54H28.88V13.71h1.243c1.08 0 1.54.405 1.54 1.566Zm-1.322-3.065h-3.525v9.359h2.065v-3.336h1.554c2.12 0 3.376-1.054 3.376-3.08 0-1.89-1.148-2.943-3.47-2.943Z"
  }),
  "64": /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M11.332.103h-1.3c-.69 0-1.25.56-1.25 1.25v61.338c0 .69.56 1.25 1.25 1.25h43.717c.691 0 1.25-.56 1.25-1.25V1.353c0-.69-.559-1.25-1.25-1.25H13.832v2.5H52.5v58.838H11.281V2.603h.051v-2.5Zm14.45 20.031c0 1.351-.594 2-2.07 2h-1.549v-3.872h1.53c1.477 0 2.09.576 2.09 1.872Zm-1.728-3.853h-4.61V28.76H22.2v-4.843h1.657l2.574 4.843h2.935l-2.97-5.456v-.072c1.35-.558 2.177-1.458 2.177-3.204 0-2.54-1.53-3.746-4.518-3.746Zm6.622 12.479h2.755V16.282h-2.755V28.76Zm11.539-8.392c0 1.387-.594 2.053-2.107 2.053h-1.603v-4.14h1.658c1.44 0 2.052.54 2.052 2.087Zm-1.764-4.087h-4.699V28.76h2.753v-4.447h2.072c2.827 0 4.501-1.405 4.501-4.106 0-2.52-1.531-3.925-4.627-3.925Z"
  })
};
var pathSizesToViewBox = {
  "16": "0 0 16 16",
  "24": "0 0 24 24",
  "32": "0 0 32 32",
  "48": "0 0 48 48",
  "64": "0 0 64 64"
};
var sizesToPathSizes = {
  "16": "16",
  "24": "24",
  "32": "32",
  "48": "48",
  "64": "64"
};
var sizes = ['16', '24', '32', '48', '64'];
var IconDeathBenefit = function IconDeathBenefit(_ref) {
  var _ref$size = _ref.size,
    sizeProp = _ref$size === void 0 ? '32' : _ref$size,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Death Benefit' : _ref$title,
    _ref$ariaHidden = _ref.ariaHidden,
    ariaHidden = _ref$ariaHidden === void 0 ? false : _ref$ariaHidden,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  var size = sizes.indexOf(sizeProp) !== -1 ? sizeProp : '32';
  return /*#__PURE__*/_react.default.createElement(_IconSVG.default, (0, _extends2.default)({
    width: size,
    height: size,
    viewBox: pathSizesToViewBox[sizesToPathSizes[size]],
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    role: "img",
    title: title,
    ariaHidden: ariaHidden
  }, props, {
    iconClass: "DeathBenefit"
  }), pathSizesToPaths[sizesToPathSizes[size]]);
};
IconDeathBenefit.sizes = [16, 24, 32, 48, 64];
IconDeathBenefit.propTypes = {
  /** Available sizes: 16, 24, 32, 48, 64. In most cases, the size will be a square (e.g., 32px X 32px), but height variances can occur. */
  size: _propTypes.default.oneOf(sizes),
  /** Similar to the 'alt' attribute on image tags, this is optional for custom tooltips and will default to the icon name if not overriden. */
  title: _propTypes.default.string,
  /** Hide icon from screen readers. */
  ariaHidden: _propTypes.default.bool,
  /** Optional custom class. */
  className: _propTypes.default.string
};
var _default = IconDeathBenefit;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@lmig/design-system-icons-react/_cjs/coverage-options/DeathBenefit.js
// module id = 1995
// module chunks = 0